const Hindi = {
  // COMMON
  language: "भाषा",
  changeLanguage: "भाषा बदलें",
  date: "तारीख",
  time: "समय",
  price: "कीमत",
  month: "महीना",
  nearbyTemples: "नज़दीकी मंदिर",
  createTemples: "मंदिर बनाएँ",
  temples: "मंदिर",
  latestTemples: "नवीनतम मंदिर",
  groupOfTemples: "मंदिरों का समूह",

// menus
   dashboard: "डैशबोर्ड",
  admission: "प्रवेश",
  report: "रिपोर्ट",
  timeTable: "समय-सारणी",
  messaging: "संदेश",
  events: "कार्यक्रम",
  master: "मास्टर",
  exam: "परीक्षा",
  download: "डाउनलोड",
  attendanceDashboard: "उपस्थिति डैशबोर्ड",
  //DASHBOARD
  templeCreateDescription:
    "मंदिर प्रोफ़ाइल बनाना सरल, सार्थक और निःशुल्क है। अपने मंदिर की कहानी से दूसरों को प्रेरित करें और एक बढ़ते आध्यात्मिक नेटवर्क का हिस्सा बनें।",

  backToSearch: "खोज पर वापस जाएँ",
  backToDashboard: "डैशबोर्ड पर वापस जाएँ",
  templeView: "मंदिर दृश्य",
  editTemples: "मंदिर संपादित करें",
  backToTemples: "मंदिरों पर वापस जाएँ",
  profile: "प्रोफ़ाइल",
  personalInfo: "व्यक्तिगत जानकारी",
  locationBackground: "स्थान और पृष्ठभूमि",
  spiritualIdentification: "आध्यात्मिक और पहचान",
  editProfile: "प्रोफ़ाइल संपादित करें",
  profilePhoto: "प्रोफ़ाइल फोटो",
  backToProfile: "प्रोफ़ाइल पर वापस जाएँ",
  saveProfile: "प्रोफ़ाइल सहेजें",
  optional: "(वैकल्पिक)",

  // TEMPLE
  templeGallery: "मंदिर गैलरी",
  mainDeity: "मुख्य देवता",
  otherDeity: "अन्य देवता",
  location: "स्थान",
  address: "पता",
  city: "शहर",
  district: "जिला",
  state: "राज्य",
  country:"देश",
  pincode: "पिनकोड",
  geographicCoordinates: "भौगोलिक निर्देशांक",
  cityTownVillage: "शहर / कस्बा / गाँव",

  availableFacilities: "उपलब्ध सुविधाएँ और पहुँच",
  ritualsGuidelines: "अनुष्ठान दिशानिर्देश",
  dressCode: "वेशभूषा नियम",
  festivalEvents: "त्योहार और कार्यक्रम",
  poojaDetails: "पूजा विवरण",
  contactInfo: "संपर्क जानकारी",
  templeTimings: "मंदिर समय",
  morning: "सुबह",
  afternoon: "दोपहर",
  sthalaVirutcham: "स्थल विरुच्छम",
  bestTime: "भ्रमण का सर्वोत्तम समय",
  atonementRituals: "इस मंदिर में प्रायश्चित अनुष्ठान",
  howToReach: "कैसे पहुँचे",
  km: "कि.मी",
  ownershipDetails: "मंदिर स्वामित्व विवरण",
  managedBy: "प्रबंधित द्वारा",

  //TEMPLE CONTACT
  templeEmail: "मंदिर ईमेल पता",
  templeOwnershipContact: "मंदिर स्वामित्व संपर्क जानकारी",
  otherContactInfo: "अन्य संपर्क जानकारी",

  // REVIEWS
  reviews: "समीक्षाएँ",
  communityReviews: "हमारे समुदाय से समीक्षाएँ",
  searchReviews: "समीक्षाएँ खोजें",
  reviewDetails: "समीक्षा विवरण",
  review: "समीक्षा",

  // EXPERIENCES
  userExperience: "अनुभव",
  shareYourExperience: "अपना अनुभव साझा करें",
  communityExperiences: "हमारे समुदाय के अनुभव",
  searchExperiences: "अनुभव खोजें",
  experienceDetails: "अनुभव विवरण",
  search: "खोजें",

  // SUGGESTIONS
  suggestUpdate: "अद्यतन सुझाव दें",
  helpImprove1: "क्या आपको इसके बारे में कुछ और जानकारी है जो हमसे छूट गई?",
  helpImprove2:
    "जानकारी को सटीक और अद्यतन बनाए रखने में मदद के लिए अपने सुझाव साझा करें।",
  suggestion: "सुझाव",
  referenceLink: "संदर्भ लिंक",
  otherGroupTemples: "इस समूह के अन्य मंदिर",

  // BUTTONS
  viewAllTemples: "सभी मंदिर देखें",
  getDirection: "दिशा प्राप्त करें",
  website: "मंदिर वेबसाइट",
  writeReview: "समीक्षा लिखें",
  addSuggestion: "सुझाव जोड़ें",
  next: "अगला",
  previous: "पिछला",
  cancel: "रद्द करें",
  submit: "जमा करें",
  updatePassword: "पासवर्ड अपडेट करें",
  updateNow: "अभी अपडेट करें",

  // INPUT
  name: "नाम",
  phoneNumber: "फ़ोन नंबर",
 mobileNumber:"मोबाइल नंबर",
  // PROFILE
  currentPassword: "वर्तमान पासवर्ड",
  newPassword: "नया पासवर्ड",
  confirmNewPassword: "नया पासवर्ड पुष्टि करें",
  firstName: "पहला नाम",
  middleName:"मध्य नाम",
  lastName: "अंतिम नाम",
  fatherName:"पिता का नाम",
   motherName:"माता का नाम",
  fullName: "पूरा नाम",
  dateOfBirth: "जन्म तिथि",
  age: "आयु",
  gender: "लिंग",
  email: "ईमेल पता",
  phone: "फ़ोन नंबर",
  bio: "जीवनी",
  religion: "धर्म",
  visitFrequency: "भ्रमण की आवृत्ति",
  maritalStatus: "वैवाहिक स्थिति",
  aadhaarNumber: "आधार संख्या",
  panNumber:"पैन नंबर",
  passportNumber: "पासपोर्ट संख्या",
  occupation: "व्यवसाय",
  bloodGroup: "रक्त समूह",

  // EMPTY
  noGuidelines: "कोई दिशानिर्देश डेटा उपलब्ध नहीं।",
  noDressCode: "कोई वेशभूषा डेटा उपलब्ध नहीं।",
  noAtonementRituals: "इस मंदिर में कोई प्रायश्चित अनुष्ठान नहीं।",
  noTransport: "कोई नज़दीकी परिवहन विकल्प उपलब्ध नहीं।",
  noReviews: "अपने मंदिर के अनुभव को साझा करने वाले पहले व्यक्ति बनें।",
  noFestivalEvents: "कोई त्योहार या कार्यक्रम डेटा उपलब्ध नहीं है",
  noPoojaData: "कोई पूजा डेटा उपलब्ध नहीं है",
  noOwnershipData: "स्वामित्व डेटा उपलब्ध नहीं है",
  noContactData: "कोई संपर्क डेटा उपलब्ध नहीं है",
  noTempleImages: "मंदिर की कोई तस्वीर उपलब्ध नहीं है।",

  // COMMON
  shareTemple: "इस मंदिर को साझा करें",
  copied: "कॉपी हो गया!",
  note: "नोट:",
  passwordNote:
    "पासवर्ड सफलतापूर्वक अपडेट करने के बाद, सुरक्षा कारणों से आपको स्वचालित रूप से लॉगिन पृष्ठ पर पुनर्निर्देशित किया जाएगा। कृपया जारी रखने के लिए अपना नया पासवर्ड उपयोग करके साइन इन करें।",
};
export default Hindi;
